export function isEmptyOrWhiteSpace(str: string): boolean {
	return str === null || str.match(/^ *$/) !== null;
}
